import styled from "vue-styled-components";

export const Content = styled.div`
    margin-bottom: 3rem;

    > section {
        display: grid;
        /* grid-template-columns: repeat(3, fit-content(33%)); */
        grid-template-columns: repeat(3, minmax(33%, 33%));
        margin-inline: -1.5rem;
        margin-bottom: 3rem;
    }

    .products-to-buy-together-action {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        span {
            margin-bottom: 1rem;
            color: ${props => props.theme?.text_site_color ?? '#4a505e'};
            font: 400 1.5rem/1.1 ${props => props.theme?.font_family ?? 'Open Sans'}, sans-serif;
            big {
                font-size: 1.8rem;
                color: ${props => props.theme?.products?.product_page?.price_color ?? '#595959'};
            }
        }

        i {
            font-size: 1.9rem;
            margin-left: -0.8rem;
        }
    }

    @media (max-width: 575px) {
        > section {
            grid-template-columns: 99%;
            gap: 3rem;
        }
    }
    /* .section-col {
        .section-product-item {
            position: relative;
            height: 100%;
            display: flex;
            flex-direction: column;

            figure {
                max-height: 15rem;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                    object-fit: contain;
                    width: 100%;
                    height: 100%;
                }
            }

            .product-to-buy-together-detailed {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                gap: 1rem;
                height: 100%;
                padding-bottom: 0.5rem;
                border-bottom: 1px solid ${props => props.theme?.border_color_site ?? '#dee2e6'};
                h3 {
                    margin: 0;
                    letter-spacing: .02rem;

                    font-family: ${props => props.theme?.font_family ?? 'Open Sans'}, sans-serif;
                    font-size: ${props => props.theme?.products?.font_size ?? '1.5rem'};
                    font-weight: ${props => props.theme?.products?.font_weight ?? 400};
                    color: ${props => props.theme?.products?.title_color ?? '#2b2b2d'};
                    text-transform: ${props => props.theme?.products?.text_transform ?? 'uppercase'};

                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: ${props => props.theme?.products?.white_space ?? 'nowrap'};
                    ${props => props.theme?.products?.white_space == 'normal' ? 'display: -webkit-box;' : ''}
                    ${props => props.theme?.products?.white_space == 'normal' ? '-webkit-box-orient: vertical;' : ''}
                    -webkit-line-clamp: ${props => props.theme?.products?.max_lines_title ?? 10};
                }

                > div {
                    span {
                        font-family: ${props => props.theme?.font_family ?? 'Open Sans'}, sans-serif; 
                        color: ${props => props.theme?.products?.price_color ?? '#595959'};
                        font-weight: ${props => props.theme?.products?.font_weight_price ?? 600};
                        font-size: 1.7rem;
                        
                        &.old-banner-price {
                            text-decoration: line-through;
                        }
                        &.old-banner-price,
                        &.from-price {
                            font-size: 1.4rem;
                            color: ${props => props.theme?.text_site_color ?? '#4a505e'};
                        }

                        & + span {
                            margin-left: 0.5rem;
                        }
                    }
                }
            }
        }
    }

    .section-col + .section-col {
        position: relative;
        &:before {
            content: '+';
            position: absolute;
            left: -6px;
            top: 50%;
            font-size: 20px;
            color: ${props => props.theme?.text_site_color ?? '#4a505e'};
        }
    }

    .check-item {
        position: absolute;
        top: -15px;
        right: -15px;
        height: 35px;
        width: 35px;
        background: #fff;
        border-radius: 50%;
        box-shadow: 0 12px 35px rgba(0, 0, 0, 0.15);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        i {
            font-size: 1.6rem;
            color: ${props => props.theme?.primary_color};
        }
    }

    @media (max-width: 575px) {
        .section-col {
            max-width: 300px;
            margin: 0 auto;
            + .section-col {
                margin-top: 3rem;
                &:before {
                    left: 50%;
                    top: -3rem;
                }
            }
        }

        .check-item {
            top: 0px;
            right: 0px;
        }
    } */
`;
